import { getCurrentSiteDomain } from '../utils/sites'
import ga from '../utils/ga'

const getListName = (pageType) => {
  if (pageType === 'category') {
    return 'Search Results: Category'
  }

  return 'Search Results: Search'
}

export const reportProductClick = (item, index, currentSite, pageType) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  ga('ec:addProduct', {
    id: item.id,
    name: item.name,
    category: `${currentSiteDomain}/${item.classification}`,
    brand: item.author_username,
    list: getListName(pageType),
    position: index
  })
  ga('ec:setAction', 'click', {
    list: getListName(pageType)
  })
  ga('send', 'event', 'Ecommerce', 'click', 'Product click: product list')
}

export const reportProductAddToCartAttempt = (item, index, currentSite, pageType) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  ga('ec:addProduct', {
    id: item.id,
    name: item.name,
    category: `${currentSiteDomain}/${item.classification}`,
    brand: item.author_username,
    list: getListName(pageType),
    position: index
  })
  ga('ec:setAction', 'add')
  ga('send', 'event', 'Ecommerce', 'click', 'Add to cart: product list')
}

export const reportProductsImpressions = (items, currentSite, itemRankOffset, pageType) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  items.forEach((item, index) => {
    ga('ec:addImpression', {
      id: item.id,
      name: item.name,
      category: `${currentSiteDomain}/${item.classification}`,
      brand: item.author_username,
      list: getListName(pageType),
      position: index + itemRankOffset
    })
  })
  ga('send', 'event', 'Ecommerce', 'view', 'Product impression', {
    nonInteraction: true
  })
}

export const reportModalPageView = ({title, page}) => {
  ga('send', {
    hitType: 'pageview',
    page,
    title
  })
}



// WEBPACK FOOTER //
// ./common/analytics/resultAnalytics.js